import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppButton.css";

export default function WhatsAppButton(props) {
  return (
    <div className="whats-app-btn-wrapper">
      <a
        href={props.whatsAppComercialLink}
        rel="noopener noreferrer"
        className="whats-app-btn-link"
        target="_blank"
        aria-label="Entre em contato via WhatsApp"
        style={{ color: props.white }}
      >
        <div
          className="whats-app-btn-container"
          style={{
            backgroundColor: props.btnColor,
          }}
        >
          <div
            id="whats-app-floating-btn"
            style={{
              background: props.whatsAppColor,
            }}
          >
            <FaWhatsapp className="whats-app-btn-icon" />
          </div>
          <h4 style={{ color: props.white }}>FAÇA SEU PLANO</h4>
        </div>
      </a>
      <a
        href={`https://wa.me/${props.whatsAppNumber}?text=Gostaria%20de%20iniciar%20atendimento%20do%20Grupo%20Krause.`}
        rel="noopener noreferrer"
        className="whats-app-btn-link"
        target="_blank"
        aria-label="Entre em contato via WhatsApp"
        style={{ color: props.white }}
      >
        <div
          className="whats-app-btn-container"
          style={{
            backgroundColor: props.btnColor,
          }}
        >
          <div
            id="whats-app-floating-btn"
            style={{
              background: props.whatsAppColor,
            }}
          >
            <FaWhatsapp className="whats-app-btn-icon" />
          </div>
          <h4 style={{ color: props.white }}>ATENDIMENTO 24H</h4>
        </div>
      </a>
    </div>
  );
}
